import { Reducer } from 'redux'
import { InternetPackageStateInterface, InternetPackageActionTypes } from '../internetPackage/types'

export const initialState: InternetPackageStateInterface = {
    internetPackage: {},
    loading: false,
    modal: false
}

const reducer: Reducer<InternetPackageStateInterface> = (state = initialState, action) => {
    switch (action.type) {
        case InternetPackageActionTypes.FETCH_INTERNET_PACKAGE_TYPES: {
            return { ...state, loading: true }
        }
        case InternetPackageActionTypes.SET_INTERNET_PACKAGE_TYPES: {
            return { ...state, loading: false, internetPackage: action.payload }
        }
        case InternetPackageActionTypes.FETCH_MODAL: {
            return { ...state, modal: action.payload }
        }
        case InternetPackageActionTypes.FETCH_ERROR: {
            return { ...state, loading: false }
        }
        default:
            return state
    }
}

export { reducer as internetPackageReducer }